/**
 * Um UUID novo. `crypto.randomUUID` só existe em contexto seguro (https ou
 * localhost); fora dele, por http no IP da rede, o envio e o diagrama não
 * podem quebrar por causa de um identificador. `getRandomValues` existe nos
 * dois e dá um UUID v4 de verdade, que o servidor aceita.
 */
export function novoId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  const b = crypto.getRandomValues(new Uint8Array(16))
  b[6] = (b[6]! & 0x0f) | 0x40
  b[8] = (b[8]! & 0x3f) | 0x80
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('')
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}
